<div class="card velocity">
	<p class="card-title">{{ title }}</p>
	<div class="circle">
		<p>{{ cost | currency: currency:'symbol':'1.0-0' }}</p>
		<app-radial-progress value="100"></app-radial-progress>
	</div>
</div>
